import React from 'react';
// import './PageNotReady.css';
export default function PageNotReady() {
  return (
    <div className='pageNotReadyMain'>
      <h4>This page is not ready to be shown</h4>
    </div>
  );
}
